import React, { } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import bgg from "assets/img/bgg.png";

import CareerForm from "components/Homepage/CareerForm";


export default function Manager() {
    
    return (
        <>
            <AdminNavbar fixed />
            <section className="">
            <div
          className=" xl:pt-32 xl:pb-16 lg:pt-32 md:pt-32 pt-32 lg:pb-16 md:pb-16 pb-16 "
          style={{
            backgroundColor: "#f0f7fa",
            backgroundImage: `url(${bgg})`,
            backgroundPosition: "center center", // Correct property name
            backgroundRepeat: "repeat", // No need to quote unless special characters
            backgroundSize: "55% auto", // No dash in property names
          }}
        >
          <div className="container mx-auto xl:px-0 px-4">
            <div className="xl:w-10/12 justify-center mx-auto text-center ">
              <p className="text-peach xl:text-2xl lg:text-2xl md:text-2xl text-xl bubblegum">
                Junior Toes
              </p>
              <h2 className="xl:text-5xl md:text-3xl lg:text-4xl text-2xl pt-2 font-bold text-black pt-2">
                Admission Manager
              </h2>
            </div>
          </div>
        </div>

                <div className="container mx-auto xl:pt-24 xl:pb-16 lg:pt-20 lg:pb-20 md:pt-20 md:pb-20 pt-20 pb-20 xl:px-0 px-4">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-4 xl:gap-12  gap-6">
                        <div className="">
                            <h3 className="text-black font-semibold xl:text-2xl text-2xl">
                                Role
                                

                            </h3>
                            <p className="xl:text-lg text-lg pt-4 xl:pt-4" style={{ lineHeight: 1.9 }}>
                                The Admission Manager will oversee the student admission process,
                                guiding parents through inquiries, applications, and enrollment, ensuring a
                                smooth and welcoming experience for new families.
                            </p>

                            <h3 className="text-black font-semibold xl:text-2xl text-2xl mt-6 xl:mt-8">
                                Qualifications
                            </h3>

                            <ul className="list-disc list-outside text-blue xl:py-6 py-6 xl:ml-0 lg:ml-4 md:ml-4 ml-4">
                                <li className="">
                                    <span className="text-black xl:text-lg text-lg">
                                    Bachelor’s degree in Marketing, Business Administration, or related field.
                                    </span>
                                </li>
                                <li className="xl:pt-4 pt-4">
                                    <span className="text-black xl:text-lg text-lg">
                                    Strong organizational and communication skills.
                                    </span>
                                </li>
                                <li className="xl:pt-4 pt-4">
                                    <span className="text-black xl:text-lg text-lg">
                                    Experience in customer service or admissions is a plus.
                                    </span>
                                </li>
                                <li className="xl:pt-4 pt-4">
                                    <span className="text-black xl:text-lg text-lg">
                                    Detail-oriented and proactive.
                                    </span>
                                </li>
                            </ul>


                        </div>

                        <div className="">
                            <h3 className="text-black font-semibold xl:text-2xl text-2xl">
                                Key Responsibilities
                            </h3>

                            <ul className="list-disc list-outside text-blue xl:py-6 py-6 xl:ml-0 lg:ml-0 md:ml-0 ml-4">
                                <li className="">
                                    <span className="text-black xl:text-lg text-lg">
                                    Manage the entire admission process from inquiry to enrollment.
                                    </span>
                                </li>
                                <li className="xl:pt-4 pt-4">
                                    <span className="text-black xl:text-lg text-lg">
                                    Develop and implement strategies to attract and engage prospective families.
                                    </span>
                                </li>
                                <li className="xl:pt-4 pt-4">
                                    <span className="text-black xl:text-lg text-lg">
                                    Provide information and support to parents regarding the school’s programs
                                    and policies.
                                    </span>
                                </li>
                                <li className="xl:pt-4 pt-4">
                                    <span className="text-black xl:text-lg text-lg">
                                    Maintain accurate records and track application statuses.
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

               <div>
                <CareerForm/>
               </div>
        {/* endd */}
            </section>
            <Footer2 />
        </>
    );
}
